module.exports = __webpack_public_path__ + "284e2e4a4f66ce7ae7dde1ec1d81ae2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/background_sounds.png
// module id = 531
// module chunks = 0